<template src="./module_form.html"></template>

<script>
import { EditModule } from '@/api/auth'

export default {
  name: 'add-module',
  data: function () {
    return {
      model: {
        item: '',
        note: ''
      },
      ruleValidate: {
        item: [{
          required: true,
          message: '必须填写模块名称',
          trigger: 'blur'
        }],
        note: [{
          required: true,
          message: '模块描述或备注不能为空',
          trigger: 'blur'
        }]
      }
    }
  },
  methods: {
    init: function (module) {
      this.model = module
    },
    handleSubmit: function (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.postForm()
        } else {
          this.$Message.error('信息填写有误!')
        }
      })
    },
    postForm: function () {
      EditModule(this.model).then(async res => {
        if (res.error) {
          this.$Message.error(res.error)
        } else {
          this.$emit('refresh')
        }
      })
    }
  }
}
</script>
